module.exports = __webpack_public_path__ + "static/media/sortAsc.90c52787.svg";